import { postCreateFile, fetchFileData, postUpdateFile, sendDeleteFile } from '../api'

export const createFile = async ({ commit, dispatch }, { data, name }) => {
  try {
    const res = await postCreateFile(data)
    if (res && res instanceof Error) throw res
    commit('TOAST_FILE', `${name} was uploaded!`)
  } catch (err) {
    commit('TOAST_ERROR', err.toast)
    return false
  }
}

export const getFiles = async ({ commit, dispatch }, { page, pageSize }) => {
  try {
    const res = await fetchFileData(page, pageSize)
    if (res && res instanceof Error) throw res
    commit('FILES', { data: res.data.results, total: res.data.total, page: res.data.page, pageSize: res.data.pageSize })
  } catch (err) {
    commit('TOAST_ERROR', err.toast)
    return false
  }
}

export const updateFile = async ({ commit, dispatch, getters }, data) => {
  try {
    const res = await postUpdateFile(getters.activeFile, data)
    if (res && res instanceof Error) throw res
    commit('TOAST_FILE', `${data.name} was updated!`)
    commit('SET_ACTIVE_FILE')
  } catch (err) {
    commit('TOAST_ERROR', err.toast)
    return false
  }
}

export const deleteFile = async ({ commit, dispatch, getters }) => {
  try {
    const file = getters.file
    const res = await sendDeleteFile(file._id)
    if (res && res instanceof Error) throw res
    commit('TOAST_FILE', `${file.name} was deleted!`)
    commit('SET_ACTIVE_FILE')
  } catch (err) {
    commit('TOAST_ERROR', err.toast)
    return false
  }
}

export const setActiveFile = ({ commit, dispatch }, data) => {
  commit('SET_ACTIVE_FILE', data)
}



// WEBPACK FOOTER //
// ./src/app/store/files/actions.js